import type { ReactNode } from "react";

/**
 * The verified/official tick.
 *
 * Lives in its own module rather than in `social-ui` because {@link Avatar} stamps it onto the
 * disc and `social-ui` imports `Avatar` — putting it there makes the graph circular. `social-ui`
 * re-exports it, so every existing import site is unchanged.
 *
 * `nudge` lifts the badge off the text baseline; it is right when the badge sits INLINE beside a
 * name and wrong when it is absolutely positioned (there is no baseline to correct for, and the
 * transform would just push it out of place) — so the avatar overlay passes `nudge={false}`.
 */
export function OfficialBadge({
  className = "",
  size = 16,
  nudge = true,
}: {
  className?: string;
  size?: number;
  nudge?: boolean;
}): ReactNode {
  return (
    <span
      className={`inline-flex flex-none items-center justify-center rounded-full bg-secondary text-ink-on-gold ${className}`}
      style={{
        width: size,
        height: size,
        ...(nudge ? { transform: `translateY(${-Math.max(1, Math.round(size * 0.12))}px)` } : {}),
      }}
      role="img"
      aria-label="حساب رسمی"
      title="حساب رسمی"
    >
      <svg
        viewBox="0 0 24 24"
        className="h-[68%] w-[68%]"
        fill="none"
        stroke="currentColor"
        strokeWidth={3.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M5 13l4 4L19 7" />
      </svg>
    </span>
  );
}
